import { render, staticRenderFns } from "./statics-count.vue?vue&type=template&id=5116dd0d&scoped=true"
import script from "./statics-count.vue?vue&type=script&lang=ts"
export * from "./statics-count.vue?vue&type=script&lang=ts"
import style0 from "./statics-count.vue?vue&type=style&index=0&id=5116dd0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5116dd0d",
  null
  
)

export default component.exports